import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

const queryFn = (params: QueryParams) => {
    return network.post('api/bo/getBaselineVsActual', params).then((response) => response.data);
};

export const useQueryGetBaselineVsActual = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getBaselineVsActual', params],
        queryFn: () => queryFn(params),
        enabled:
            Boolean(params.contractId) &&
            Boolean(params.projectId) &&
            Boolean(params.actualMetaDataId) &&
            Boolean(params.baselineMetaDataId) &&
            Boolean(params.graphType),
    });
};

interface QueryParams extends NarrativeRequest {
    contractId?: number | null;
    projectId?: number | null;
    actualMetaDataId?: number;
    baselineMetaDataId?: number;
    filter: {
        filters?: IFilter[];
    };
    graphType: string;
    isPartialCompletion: string;
}

interface QueryFnResponse {
    baseVersionId: number;
    actualVersionId: number;
    baseLine: {
        id: number;
        versionName: string;
        versionDate: number;
        startDate: number;
        finishDate: number;
        duration: number;
        totalMilestones: number;
        totalMilestonesComplited: number;
        totalMilestonesNotCompleted: number;
        totalTasks: number;
        totalTDAComplited: number;
        totalTasksNotCopmleted: number;
        maxWBSLevel: number;
    };
    actual: {
        id: number;
        versionName: string;
        versionDate: number;
        startDate: number;
        finishDate: number;
        duration: number;
        totalMilestones: number;
        totalMilestonesComplited: number;
        totalMilestonesNotCompleted: number;
        totalTasks: number;
        totalTDAComplited: number;
        totalTasksNotCopmleted: number;
        maxWBSLevel: number;
    };
    criticalityPlannedPercent: number;
    criticalityActualPercent: number;
    completionPlannedPercent: number;
    completionActualPercent: number;
    submittedPlannedPercent: number | null;
    submittedActualPercent: number | null;
    info?: IToolTip;
    latestSubmittedAnticipatedDelay: string;
    criticalityScheduleAdherence: number;
    completionScheduleAdherence: number;
    resourceActualPercent: number;
    resourcePlannedPercent: number;
    resourceScheduleAdherence: number;
}

type QueryResponse = QueryFnResponse & {};
